import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M1813.33333,1557.19467 C1255.57333,1684.02133 664.853333,1684.02133 106.666667,1557.19467 L106.666667,468.448 C664.426667,341.621333 1255.14667,341.514667 1813.33333,468.448 L1813.33333,1557.19467 Z M1879.04,374.261333 C1278.72,230.688 640.64,230.794667 40.96,374.261333 L0,384.074667 L0,1641.568 L40.96,1651.38133 C341.013333,1723.168 650.24,1759.43467 960,1759.43467 C1269.86667,1759.43467 1579.2,1723.168 1879.04,1651.38133 L1920,1641.568 L1920,384.074667 L1879.04,374.261333 Z M853.333333,786.986667 L1229.65333,1012.8 L853.333333,1238.61333 L853.333333,786.986667 Z M746.666667,1426.98667 L1437.01333,1012.8 L746.666667,598.613333 L746.666667,1426.98667 Z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconVideoLine = /*#__PURE__*/function (_Component) {
  _inherits(IconVideoLine, _Component);

  var _super = _createSuper(IconVideoLine);

  function IconVideoLine() {
    _classCallCheck(this, IconVideoLine);

    return _super.apply(this, arguments);
  }

  _createClass(IconVideoLine, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconVideo",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconVideoLine.displayName = "IconVideoLine";
  return IconVideoLine;
}(Component);

IconVideoLine.glyphName = 'video';
IconVideoLine.variant = 'Line';
IconVideoLine.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconVideoLine;
export { IconVideoLine };